var downloadUrl = "";
var $button;
var $container;
var $containerLoader;
var $containerNoResult;
var $productCategorySelect;
var $languageSelect;
var $textNoResult;

$(document).ready(function () {

    $button = $('#download');
    $button.click(handleDownload);

    downloadUrl = $button.attr('data-target-url');

    $container = $('#smeg-how-to-connect-container');
    $containerLoader = $('#smeg-how-to-connect-loader');
    $containerLoader.hide();
    $containerNoResult = $('#smeg-how-to-connect-no-result');
    $textNoResult = $('#no-result-message');
    $containerNoResult.hide();

    $productCategorySelect = $('#select-product-category');
    $languageSelect = $('#select-language');
});

function handleDownload() {

    showProgressLoader();

    var selectedProductCategory = $productCategorySelect.val();
    if (!selectedProductCategory) {
        showMissingProductCategory();
        return;
    }

    var selectedLanguage = $languageSelect.val();
    if (!selectedLanguage) {
        showMissingLanguage();
        return;
    }

    $.get(
        downloadUrl,
        {
            "productCategory": selectedProductCategory,
            "language": selectedLanguage
        },
        showContent,
        'html'
    ).fail(function () {
        showNoContent(window.smeg.noResultMessage);
    });
}

function showMissingProductCategory() {
    showNoContent(window.smeg.missingCategoryLabel)
}

function showMissingLanguage() {
    showNoContent(window.smeg.missingLanguage)
}

function showProgressLoader() {
    $containerNoResult.hide();
    $containerLoader.show();
}

function showContent(content) {
    $containerLoader.hide();
    $container.empty();
    $container.show();
    $container.append(content);
}

function showNoContent(message) {
    $container.empty();
    $containerLoader.hide();
    $textNoResult.html(message);
    $containerNoResult.show();
}
